<ngx-skeleton-loader
  [theme]="skeletonDataGridTheme"
  count="30"
></ngx-skeleton-loader>
